import React from "react";

import { FormControlLabel, SxProps, Typography } from "@mui/material";

import Checkbox from "@rui/Checkbox";

const DontShowThisAgain = ({
  checked,
  onChange,
  sx,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  sx?: SxProps;
}) => {
  const handleChange = (event: React.SyntheticEvent, checked: boolean) =>
    onChange(checked);

  return (
    <FormControlLabel
      control={<Checkbox checked={checked} />}
      onChange={handleChange}
      label={
        <Typography variant="bodySecondaryReg" color="shades.neutral.600">
          Don't show this again
        </Typography>
      }
      sx={{ marginLeft: 0, ...sx }}
    />
  );
};

export default DontShowThisAgain;
